import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchive1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArchive1"><Path d="M22 3H2V7H22V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 8.5H3V21H21V8.5ZM9.25 11H14.75V12.5H9.25V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArchive1;
